enum ChannelPreview {
  EmptyChannel = "There's nothing here yet",
  FileMessage = "1 File",
}

enum PatientDocumentValidationStatus {
  Clean = "CLEAN",
  Invalid = "INVALID",
  New = "NEW",
  Unknown = "UNKNOWN",
}

enum MessagesTabSubDeepLinks {
  Channel = "channel",
}

export {
  ChannelPreview,
  MessagesTabSubDeepLinks,
  PatientDocumentValidationStatus,
};
